// Design tokens, the one place for colours and fonts. The calculators use
// the dark palette; the light one is for the Quote Log / admin pages later
// (defined, not applied yet).
export const tokens = {
  dark: {
    bg: "#07141E", surface: "#0E2131", ink: "#E6EEF4", muted: "#8FA3B3",
    line: "#1F3648", accent: "#7E98FF", accentSoft: "#17284A",
    good: "#57C98F", goodSoft: "#10301F", warn: "#E8AC4A", warnSoft: "#33250D",
  },
  light: {
    bg: "#F3F6F8", surface: "#FFFFFF", ink: "#081F2D", muted: "#5A6B78",
    line: "#DCE3E9", accent: "#2F55D4", accentSoft: "#E6ECFB",
    good: "#23784A", goodSoft: "#E3F2E9", warn: "#A9670A", warnSoft: "#FBF0DD",
  },
};

export const fonts = {
  display: "'Barlow Condensed','Arial Narrow',sans-serif",
  body: "'Source Sans 3','Helvetica Neue',Arial,sans-serif",
  mono: "'IBM Plex Mono',ui-monospace,Menlo,monospace",
};
export const FONTS_HREF = "https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@600;700&family=IBM+Plex+Mono:wght@500&family=Source+Sans+3:wght@400;600;700&display=swap";

// A palette as CSS custom properties (accentSoft -> --accent-soft), for a
// stylesheet or a style={...} on a page root.
export function cssVars(palette) {
  return Object.fromEntries(Object.entries(palette).map(([k, v]) => [`--${k.replace(/[A-Z]/g, c => "-" + c.toLowerCase())}`, v]));
}

// Shared type styles from the reference reports.
export const type = {
  eyebrow: { fontSize: "0.78rem", fontWeight: 700, letterSpacing: "0.12em", textTransform: "uppercase" },
  keyFigure: { fontFamily: fonts.display, fontSize: "2.6rem", fontWeight: 700, lineHeight: 1, letterSpacing: "0.01em" },
  statLabel: { fontSize: "0.8rem" },
  statValue: { fontFamily: fonts.mono, fontWeight: 500, fontVariantNumeric: "tabular-nums" },
  pill: { borderRadius: 999, fontSize: "0.72rem", fontWeight: 700, letterSpacing: "0.06em", textTransform: "uppercase", padding: "3px 10px" },
};
